import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ColumnChart } from "react-chartkick";
import { ReportService } from "../Services/ReportService";
import {
  Paper,
  Grid,
  Typography,
  Fade,
  CircularProgress
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { toInt, format_date_only_new } from "../Utils";
import moment from "moment";
import { Link } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  typography: {},
  section: {
    width: "100%",
    minHeight: 453,
    overflow: "auto",
    overflowX: "auto",
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));

export default function ReturnsSection(props) {
  let { days, title, sectionStyle, showProgress = true, startdate, enddate } = props;

  const classes = useStyles();

  const section = sectionStyle ? sectionStyle : classes.section;

  const [returnsRow, setReturnsRow] = useState([]);
  const [returnsData, setReturnsData] = useState([]);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    setFetching(true);
    ReportService.returnsSummary(days ? days : null, startdate ? startdate : null, enddate ? enddate : null)
      .then(data => {
        let returns_row = [];
        let returns_data = [];
        if (data.summary.length > 0) {
          let total = 0;
          total = data.summary.reduce(function(accumulator, currentValue) {
            return accumulator + toInt(currentValue.returned_count);
          }, total);
          returns_row.push(
            <Typography
              display="block"
              key={"OUTWARD_TOTAL"}
              className={classes.typography}
              variant="h6"
              color="secondary"
              style={{ marginTop: 10, marginBottom: 30 }}
            >
              {days ? `Total returns in the last ${days} days: ${total}` : `Total returns: ${total}` }
            </Typography>
          );
          data.summary.forEach((element, index) => {
            returns_data.push([
              moment(element.schedule_date).format(format_date_only_new),
              toInt(element.returned_count)
            ]);
          });
        }
        setReturnsRow(returns_row);
        setReturnsData(returns_data);
        
        setFetching(false);
      })
      .catch(error => {
        console.log(error);
        setFetching(false);
      });
  }, [startdate, enddate, days]);

  return (
    <Paper className={section}>
      <Grid container direction="column">
        <Grid
          item
          xs={12}
          sm
          container
          direction="column"
          style={{ paddingTop: 16 }}
        >
        { title &&
          <Grid item xs>
            <Typography variant="h6">
                <React.Fragment>{title}
                    <Link to='/report/store/returns' style={{ textDecoration: 'none', float: 'right', fontSize: 14, cursor: 'pointer' }}>More details</Link>
                </React.Fragment>
            </Typography>
          </Grid>
        }
          <Grid
            item
            xs
            sm
            container
            direction="row"
            alignItems="flex-end"
            justify="space-evenly"
            style={{ paddingTop: 16 }}
          >
            <Grid item xs>
              {returnsRow}
            </Grid>
            <ColumnChart data={returnsData} ytitle="Count" xtitle="Date" />
          </Grid>
        </Grid>
      </Grid>
      {showProgress && (
        <Fade
          in={fetching}
          style={{
            transitionDelay: fetching ? "10ms" : "0ms"
          }}
          unmountOnExit
        >
          <CircularProgress style={{ marginTop: 20 }} />
        </Fade>
      )}
    </Paper>
  );
}

ReturnsSection.propTypes = {
  title: PropTypes.string,
  days: PropTypes.number,
  startdate: PropTypes.object,
  enddate: PropTypes.object,
  sectionStyle: PropTypes.string,
  showProgress: PropTypes.bool
};
